import React, { useEffect, useState } from 'react';
import { Box, Button, TextField } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { isValidPassword, validate } from 'utils/Validation';

interface Props {
    onSubmit: (password: string) => void;
    isProcessing: boolean;
    errorMessage?: string;
    submitLabel?: string;
}

const SetFirstPasswordForm: React.FC<Props> = ({
    onSubmit,
    isProcessing,
    errorMessage,
    submitLabel = 'Save password'
}) => {
    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [showErrors, setShowErrors] = useState(false);

    const [errors, setErrors] = useState({
        password: false,
        repeatPassword: false,
    });

    const validators = [
        {
            fieldName: 'password',
            fieldValue: password,
            isValid: isValidPassword,
        },
        {
            fieldName: 'repeatPassword',
            fieldValue: repeatPassword,
            isValid: (v: string) => v === password,
        },
    ];

    useEffect(() => {
        validate(validators, setErrors);
    }, [password, repeatPassword]);

    const handleSubmit = () => {
        if (!isProcessing) {
            if (validate(validators, setErrors)) {
                onSubmit(password);
            } else {
                setShowErrors(true);
            }
        }
    };

    return (
        <form>
            <Grid container spacing={1}>
                <Grid xs={12}>
                    <TextField
                        fullWidth
                        label="Password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        error={showErrors && errors.password}
                    />
                </Grid>
                {showErrors && errors.password && (
                    <Grid xs={12}>
                        <Box color="error.main" textAlign="center" mt={1}>
                            Password is invalid.
                        </Box>
                    </Grid>
                )}
                <Grid xs={12}>
                    <TextField
                        fullWidth
                        label="Repeat Password"
                        type="password"
                        value={repeatPassword}
                        onChange={(e) => setRepeatPassword(e.target.value)}
                        placeholder="Repeat Password"
                        error={showErrors && errors.repeatPassword}
                    />
                </Grid>
                {showErrors && errors.repeatPassword && (
                    <Grid xs={12}>
                        <Box color="error.main" textAlign="center" mt={1}>
                            Password doesn't match.
                        </Box>
                    </Grid>
                )}
                {errorMessage && (
                    <Grid xs={12}>
                        <Box color="error.main" textAlign="center" mt={2}>
                            {errorMessage}
                        </Box>
                    </Grid>
                )}
            </Grid>
            <Box sx={{ width: '100%', textAlign: 'center', pt: 2, mt: 4 }}>
                <Button variant="contained" color="primary" onClick={handleSubmit} disabled={isProcessing}>
                    {submitLabel}
                </Button>
            </Box>
        </form>
    );
};

export default SetFirstPasswordForm;
